import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import pinia from './store';
import MaskaPlugin from './plugins/maska'

const app = createApp(App);

// Configure NProgress
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 100,
  minimum: 0.08,
  easing: 'ease',
  speed: 500,
  template: '<div class="bar" role="bar" style="background: blue; height: 3px;"><div class="peg"></div></div>'
});

// Router progress bar hooks
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

// Make NProgress available globally if needed
app.config.globalProperties.$nprogress = NProgress;

// Register plugins
app.use(pinia);
app.use(router);
app.use(MaskaPlugin)
app.use(vuetify);

app.mount('#app');
